
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 3 2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#009543","d":"M0 0h3v2H0z"}}),_c('path',{attrs:{"d":"M0 2l2-2h1v2z","fill":"#FBDE4A"}}),_c('path',{attrs:{"d":"M3 0v2H1z","fill":"#DC241F"}})])
          )
        }
      }
    